import { styled } from '@mui/material'

export const Card = styled('div')(() => ({
  padding: '24px',
  borderRadius: '8px',
  backgroundColor: '#fff',
}))

export const Text = styled('div')(() => ({
  flexShrink: 0,
  fontSize: '16px',
  color: '#000',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const Text2 = styled('div')(() => ({
  fontSize: '14px',
  fontWeight: 300,
  color: 'rgba(0,0,0,0.5)',
}))

export const Text3 = styled('div')(() => ({
  fontSize: '14px',
  fontWeight: 300,
  color: 'rgba(0,0,0,0.2)',
}))

export const TextWhite2 = styled('div')(() => ({
  fontSize: '14px',
  color: '#fff',
  fontWeight: 300,
}))

export const SerialText = styled(Text)(() => ({
  fontSize: '14px',
  boxShadow: ' 0px 4px 10px 0px rgba(0,28,85,0.06)',
  borderRadius: '50%',
  marginRight: '8px',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})
